import React, {FC, ReactNode} from 'react';
import {StyleProp, ViewStyle} from 'react-native';
import Animated from 'react-native-reanimated';
import {style} from './Header.style';
import {iOSInAppBrowserVideoAd} from 'ui/helpers';

interface HeaderProps {
  readonly children: ReactNode;
  readonly visible?: boolean;
  readonly sticky?: boolean;
  readonly style?: StyleProp<ViewStyle>;
}

const Header: FC<HeaderProps> = ({children, sticky = true, style: customStyle}) => (
  <Animated.View style={[style.header, iOSInAppBrowserVideoAd && sticky && style.stickyHeader, customStyle]}>
    {children}
  </Animated.View>
);

export {Header};
